/**
 * 管理日报/月报 API 工厂函数。
 */

import type {
  ManagementDailyReportQueryParams,
  ManagementMonthlyReportQueryParams,
  ManagementReportResponse,
} from '../../types/management'
import type { IRequestClient } from '../core/client'
import { API_ROUTES } from '../routes'

export function createManagementApi(client: IRequestClient) {
  return {
    /**
     * 获取管理日报聚合数据。
     */
    getDailyReport(params?: ManagementDailyReportQueryParams) {
      return client.get<ManagementReportResponse>(
        API_ROUTES.management.reportsDaily,
        { params },
      )
    },

    /**
     * 获取管理月报聚合数据。
     */
    getMonthlyReport(params?: ManagementMonthlyReportQueryParams) {
      return client.get<ManagementReportResponse>(
        API_ROUTES.management.reportsMonthly,
        { params },
      )
    },
  }
}
